module.exports = "/packs/media/modules/startups/quality-check/components/QualityCheck/images/exampleWineBack-29a101a3da77bc405a7d258b6fb4aa0e.png";